// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bD5Qv","widthFull":"styles_widthFull__J1xIK","widthSmall":"styles_widthSmall__ldQpF"};